'use strict';

DoohApps
    .service('InvoiceBLL', ['Voucher', 'Invoice',
        function (Voucher, Invoice) {
            this.getCompanyInvoices = function (callback, filter) {
                Invoice.getCompanyInvoices(function (data) { returnContent(callback, data); }, filter)
            }

            this.getCompanyPOOverview = function (callback, filter) {
                Invoice.getCompanyPOOverview(function (data) { returnContent(callback, data); }, filter)
            }

            this.getCompanyConsumerVouchers = function (callback) {
                Voucher.getCompanyConsumerVouchers(function (data) { returnContent(callback, data); })
            }

            function returnContent(callback, data) {
                callback(data.Data.Content);
            }

            this.VoucherFiltering = function (callback, objectFilterOptions) {
                Voucher.voucherFiltering(function (data) { callback(data); }, objectFilterOptions);
            }

            this.saveNewVoucher = function (callback, dataObject) {
                Voucher.addVoucher(function (data) { responseHandler(callback, data); }, dataObject);
            };

            this.getCompaniesCredits = function (callback, filter) {
                Invoice.getCompaniesCredits(function (data) { callback(data) }, filter);
            }

            this.AddCredits = function (callback, transaction) {
                Invoice.addCredits(function (data) { callback(data) }, transaction);
            }

            this.setVoucherInvalid = function (callback, voucherID) {
                Voucher.setVoucherInvalid(function (data) { callback(data) }, voucherID);
            };

            this.getVoucherUsage = function (callback, data) {
                Voucher.getVoucherUsage(function (data) { callback(data) }, data);
            }

            function responseHandler(callback, data) {
                callback({
                    hasError: data.hasError || (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                    error: getErrorMessage(data),
                    message: data.message || (data.Data != undefined ? data.Data.message : null),
                    content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : {}) : {}
                });
            }

            function getErrorMessage(data) {
                if (data.hasError)
                    return data.errors[0];

                return data.error_description || data.error || (data.Data != undefined ? data.Data.error : null);
            }
        }]);